import React from 'react';
import styled from 'styled-components';

import {FilterSelector} from '@bootcamp/web/src/components/QBank/SidebarTop';


const SubjectSelector = styled(FilterSelector)`
  width: 250px;
  min-width: auto;
  max-width: auto;
  color: white;
  padding: 13px 16px;
  background-position: calc(100% - 16px) 50%;
  margin: 0;

  ${({theme}) => theme.mediaQueries.mobileXl} {
    width: 100%;
  }
`;

export const Selector = ({bootcamp, setSelection, options=[]}) => (
  bootcamp === 'dat'
    ? <SubjectSelector onChange={event => setSelection(event.target.value)}>
        {options.map(option => <option key={option.value} value={option.value}>{option.text}</option>)}
      </SubjectSelector>
    : <SubjectSelector onChange={event => setSelection(event.target.value)}>
        {options.map(option => <option key={option.value} value={option.value}>{option.text}</option>)}
      </SubjectSelector>
);